export default "/images/f256cac83006c75cb261e77ba6dd2a93.avif";